'use server'

import { apiRequest, ApiResponse } from '../request'

export interface AutoPaymentRecurring {
    id: number
    status: 'ACTIVE' | 'PAUSED' | 'CANCELLED'
    creditCardNumber: string | null
    creditCardBrand: string | null
    nextChargeDate: string | null
    dueDay: number
}

export interface AutoPaymentStatus {
    /** Ciclo corrente já quitado: ativar agora só guarda o cartão para o próximo. */
    currentPeriodPaid: boolean
    subscription: {
        id: number
        price: number | null
        recurrence: string | null
        dueDay: number
        origin: string
    } | null
    recurring: AutoPaymentRecurring | null
}

export interface ActivateAutoPaymentData {
    creditCard: {
        holderName: string
        number: string
        expiryMonth: string
        expiryYear: string
        ccv: string
    }
    creditCardHolderInfo: {
        name: string
        email: string
        cpfCnpj: string
        postalCode: string
        addressNumber: string
        phone?: string
    }
    consent: boolean
}

export async function getAutoPaymentStatus(): Promise<
    ApiResponse<AutoPaymentStatus>
> {
    return apiRequest<AutoPaymentStatus>('auto-payment/status', {})
}

export async function activateAutoPayment(
    data: ActivateAutoPaymentData,
): Promise<
    ApiResponse<{
        success: boolean
        paymentStatus: string | null
        charged: boolean
    }>
> {
    return apiRequest<{
        success: boolean
        paymentStatus: string | null
        charged: boolean
    }>(
        'auto-payment/activate',
        { data },
        'post',
    )
}

export async function cancelAutoPayment(
    recurringId: number,
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest<{ success: boolean }>(
        `payment/recurring-purchases/${recurringId}/cancel`,
        {},
        'patch',
    )
}

export async function resumeAutoPayment(
    recurringId: number,
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest<{ success: boolean }>(
        `payment/recurring-purchases/${recurringId}/resume`,
        {},
        'patch',
    )
}
